import React, { useState } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Form, FormGroup, Label, Input } from "reactstrap";
import useRequests from '../../../Utils/useRequests';
import { useHistory } from "react-router-dom";

const AddRulesToDigBy = ({ parent, onClose }) => {
  const { postRequest } = useRequests();
  const [loading, setLoading] = useState(false);
  const [title, setTitle] = useState("");
    const history = useHistory();
    React.useEffect(() => {
      if (localStorage.getItem('admin_type') !== 'admin') {
        history.replace('/dashboard');
      }
    }, [history]);
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const payload = {
      parent_id: parent ? parent.rtdb_id : null,
      title,
      lang: localStorage.getItem("I18N_LANGUAGE") || "eng"
    };
    const res = await postRequest('add-rules-to-dig-by', JSON.stringify(payload));
    setLoading(false);
    onClose(res && res.code === 200 ? 'success' : 'error', res.message);
  };

  return (
    <Modal isOpen toggle={onClose}>
      <ModalHeader toggle={onClose}>
        Add {parent ? "Sub" : "Main"} Rules To Dig By
      </ModalHeader>
      <Form onSubmit={handleSubmit}>
        <ModalBody>
          <FormGroup>
            <Label>Title</Label>
            <Input value={title} onChange={e => setTitle(e.target.value)} required />
          </FormGroup>
        </ModalBody>
        <ModalFooter>
          <Button color="primary" type="submit" disabled={loading}>
            {loading ? "Adding..." : "Add"}
          </Button>
          <Button color="secondary" onClick={onClose}>Cancel</Button>
        </ModalFooter>
      </Form>
    </Modal>
  );
};

export default AddRulesToDigBy;